<template>
    <Spinner v-if="topPageStore.isLoading" />

    <div id="bst-wrap">
      <div class="l-project-wrap l-project-wrap--mypage">
        <Header />
        <section class="l-content-area">
          <div class="l-content">

            <!-- MYPAGE -->
            <section class="p-bloc p-bloc--mypage">
              <div class="p-bloc__content l-wrap__outer">
                <div class="l-wrap__inner">

                  <section class="p-mypage">
                    <NavbarMyPage/>
                    <!-- Side Menu -->
                    <SideMenu/>

                    <!-- Mypage Content -->
                    <div class="p-mypage__content">
                      <div class="mypage-content">
                        <News v-if="topPageStore.newsList?.length > 0"/>
                        
                        <!-- dashboard -->
                        <div class="p-mypage__dashboard">
                          <section class="dashboard__tab">
                            <ul>
                              <li class="tab is-active"><a href="#dashboard-merchant">{{ $t('LABEL_USED_MERCHANT') }}</a></li>
                              <li class="tab"><a href="#dashboard-transaction">{{ $t('LABEL_TRANSACTION_HISTORY') }}</a></li>
                            </ul>
                          </section>

                          <section class="dashboard__content">
                            <div id="dashboard-merchant" class="dashboard__list dashboard__list--merchant">
                              <CompanyApplications v-bind:company-apps="topPageStore.registeredApps" @refresh-merchants="refreshTopPage"/>
                              <div class="dashboard__more">
                                  <div class="c-btn__more-list"><a href="/merchant-list">{{ $t('LABEL_SHOW_ALL') }}</a></div>
                              </div>
                            </div>

                            <!-- transaction -->
                            <div id="dashboard-transaction" class="dashboard__list dashboard__list--transaction" style="display: none;">
                              <Transactions v-bind:transactions="topPageStore.transactions"/>
                              <!-- more -->
                              <div class="dashboard__more">
                                <div class="c-btn__more-list"><a href="/transaction-history">{{ $t('LABEL_SHOW_ALL') }}</a></div>
                              </div>
                            </div>
                          </section>
                        </div>

                      </div><!-- .mypage-content -->
                    </div>

                  </section>

                </div>
              </div>
            </section>
          </div><!-- .l-content -->
        </section><!-- .l-content-area -->

      </div><!-- .l-project-wrap -->
      <Footer/>
    </div>
</template>

<script setup>
import NavbarMyPage from "@/components/NavbarMyPage.vue";
import Footer from "@/components/Footer.vue";
import SideMenu from "@/components/SideMenu.vue";
import Header from "@/components/Header.vue";
import Transactions from "@/components/Transactions.vue";
import News from "@/components/News.vue";
import { onBeforeMount } from "vue";
import { useTopPageStore } from "@/stores/topPageStore";
import { useRouter } from "vue-router";
import CompanyApplications from "@/components/CompanyApplications.vue";
import { useUserStore } from "@/stores/userStore";
import Spinner from "@/components/Spinner.vue";

const router = useRouter();
const topPageStore = useTopPageStore();

onBeforeMount(async () => {
    await topPageStore.getTopPageData();
    await useUserStore().isValidUserInfo();
});

function refreshTopPage(){
    topPageStore.getTopPageData();
}
</script>